import * as Dialog from '@radix-ui/react-dialog';
import { useState } from 'react';
import { ticketsService } from 'views/services/ticketsService';

type ScheduleDialogProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  ticketId: string;
};

export function ScheduleDialog({
  open,
  setOpen,
  ticketId,
}: ScheduleDialogProps) {
  const [scheduledDate, setScheduledDate] = useState('');

  const handleConfirm = async () => {
    const result = await ticketsService.scheduleControlForTicket(
      ticketId,
      scheduledDate
    );

    if (result) {
      setOpen(false);
    }
  };

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/30 z-50 backdrop-blur-sm" />
        <Dialog.Content className="fixed top-1/2 left-1/2 z-50 w-full h-[80vh] max-w-[90vw] -translate-x-1/2 -translate-y-1/2 rounded-lg bg-white dark:bg-navy-800 dark:text-white p-6 shadow-lg">
          <Dialog.Title className="text-lg font-semibold text-center mb-4">
            Ticket #{ticketId}
          </Dialog.Title>
          <p className="mb-3 text-sm text-gray-700 text-center">
            Select the date to schedule this ticket:
          </p>

          <input
            type="date"
            value={scheduledDate}
            onChange={e => setScheduledDate(e.target.value)}
            className="w-full px-3 py-2 border rounded mb-4"
          />

          <div className="flex justify-end gap-2">
            <Dialog.Close asChild>
              <button className="px-4 py-2 text-sm border text-white rounded bg-red-500 hover:bg-red-400">
                Cancel
              </button>
            </Dialog.Close>
            <button
              onClick={handleConfirm}
              disabled={!scheduledDate}
              className="px-4 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Confirm
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
